/**
 * Alert Container Component
 * 
 * Global alert container that displays alerts from Redux store.
 * Automatically removes alerts after their duration expires.
 */

import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Alert } from "react-bootstrap";
import { selectAlerts, removeAlert } from "../../redux/alertSlice";

const AlertContainer = () => {
  const dispatch = useDispatch();
  const alerts = useSelector(selectAlerts);

  // Group alerts by position
  const alertsByPosition = alerts.reduce((acc, alert) => {
    const position = alert.position || "top-right";
    if (!acc[position]) {
      acc[position] = [];
    }
    acc[position].push(alert);
    return acc;
  }, {});

  // Auto-remove alerts after duration
  useEffect(() => {
    alerts.forEach((alert) => {
      if (alert.duration > 0) {
        const timer = setTimeout(() => {
          dispatch(removeAlert(alert.id));
        }, alert.duration);

        return () => clearTimeout(timer);
      }
    });
  }, [alerts, dispatch]);

  return (
    <>
      {Object.entries(alertsByPosition).map(([position, positionAlerts]) => (
        <div key={position} className={`position-fixed p-3 ${position === "top-right" ? "top-0 end-0" : position === "top-left" ? "top-0 start-0" : position === "bottom-right" ? "bottom-0 end-0" : "bottom-0 start-0"}`} style={{ zIndex: 1080 }}>
          {positionAlerts.map((alert, index) => (
            <div
              key={alert.id}
              style={{
                marginBottom: index < positionAlerts.length - 1 ? "0.5rem" : 0,
              }}
            >
              <Alert
                variant={alert.type || "info"}
                dismissible
                onClose={() => dispatch(removeAlert(alert.id))}
                className="mb-0 shadow"
                style={{ minWidth: "300px", maxWidth: "500px" }}
              >
                {Array.isArray(alert.messages)
                  ? alert.messages.map((m, i) => <div key={i}>{m}</div>)
                  : (alert.message || "")}
              </Alert>
            </div>
          ))}
        </div>
      ))}
    </>
  );
};

export default AlertContainer;

